import {Footer} from '@deere/fuel-react';
import {Box} from '@mui/material';
import {FC, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Helmet} from 'react-helmet-async';
import Routes from './components/Routes';
import Header from './components/Header';
import {OktaAuth, toRelativeUrl} from '@okta/okta-auth-js';
import {useNavigate} from 'react-router-dom';
import {Security} from '@okta/okta-react';

export const App: FC<unknown> = () => {
    const {t} = useTranslation();
    // Memoize the OktaAuth instance so it is created ONCE for the lifetime of
    // the App component. Previously `new OktaAuth({...})` ran on every render,
    // producing a fresh object reference each time. <Security> then republished
    // a new `authState`, which fired every `useEffect([authState])` across the
    // app and caused a storm of duplicate backend calls.
    const oktaAuth = useMemo(() => new OktaAuth({
        // eslint-disable-next-line no-process-env
        issuer: `${process.env.REACT_APP_ISSUER}`,
        // eslint-disable-next-line no-process-env
        clientId: `${process.env.REACT_APP_CLIENT_ID}`,
        redirectUri: `${window.location.origin }/login/callback`,
        scopes: ['openid', 'profile', 'email', 'jduAdminAdGroups', 'jduadgroups'],
        pkce: true
    }), []);
    const navigate = useNavigate();
    const restoreOriginalUri = (_oktaAuth: any, originalUri: any): any => {
        navigate(toRelativeUrl(originalUri || '/', window.location.origin));
    };

    return (
        <Box
            display='flex'
            flexDirection={'column'}
            minHeight='100vh'
        >
            {/* the Helmet can be added to each page you would like to update the page title on */}
            <Helmet>
                <title>{t('app.title')}</title>
            </Helmet>
            <Security
                oktaAuth={oktaAuth}
                restoreOriginalUri={restoreOriginalUri}
            >
                <Header/>
                <Box
                    component='main'
                    flexGrow={1}
                >
                    <Routes/>
                </Box>
                {/* setting minHeight to pageMinHeight is used for the sticky footer */}
                <Footer/>
            </Security>
        </Box>
    );
};

export default App;
